import { makeStyles } from "@material-ui/core/styles";

const gameButtonStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		minHeight: 50,
		minWidth: 10,
		background:
			"linear-gradient(333.43deg, rgba(0,0,0,0.1) 0%, rgba(255,255,255,0.1) 100%)",
		border: ({ selected }) =>
			selected ? "1px solid #fff" : "1px solid rgba(255,255,255,0.2)",
		// Overrides for fixing the issue with nested themes.
		color: theme.palette.gameMode.primary,
		[theme.breakpoints.only("xs")]: {
			fontSize: "3vw"
		},
		[theme.breakpoints.up("sm")]: {
			fontSize: "1.11vw"
		},
		fontFamily: "Overpass",
		opacity: ({ disabled }) => (disabled ? 0.25 : 1)
	},
	playerButton: {
		[theme.breakpoints.only("xs")]: {
			minHeight: "58px",
			alignItems: ({ positionCode }) => !positionCode && "flex-start"
		}
	}
}));

export default gameButtonStyles;
